import { ApiConnectionSelectedOptions } from './api-connections-selected-options.model';

/* eslint-disable @typescript-eslint/naming-convention */
export class ApiConnectionsModel {
	public connectionId: string;
	public serverPath?: string;
	public serverAlias?: string;
	public apiKey?: string;
	public selectedOptions?: ApiConnectionSelectedOptions;

	public constructor(value: Partial<ApiConnectionsModel>) {
		this.connectionId = value.connectionId;
		this.serverPath = value.serverPath;
		this.serverAlias = value.serverAlias;
		this.apiKey = value.apiKey;
		this.selectedOptions = value.selectedOptions;
	}
}
